import { Fragment } from "react";
import { Mui } from "@osu/react-ui";
import useQuestionsFromS3Path from "../../hooks/useQuestionsFromS3Path";
import { formStyles } from "../HTML";
import PreviewQuestion from "./Question";
import InfoBox from "./InfoBox";
import FormLoader from "../../Loaders/components/Form";

function PreviewForm() {
  const { ids: questionIds, isLoading,  } = useQuestionsFromS3Path();
  if(isLoading) {
    return <FormLoader />
  }
  return (
    <Fragment>
      <InfoBox questionsLength={questionIds?.length} />
      <Mui.Box component="form" sx={(theme) => formStyles(theme)}>
        {questionIds.map((id, index) => (
          <PreviewQuestion key={id + "#" + index} id={id} />
        ))}
      </Mui.Box>
    </Fragment>
  );
}

export default PreviewForm;
